<template>
  <WizardContainer
    width="800px"
    height="500px"
  >
    <WizardContent
      :graphic="{
        type: 'gradient',
        assetsPath: 'image-demo-request',
      }"
    >
      <h4 class="mt-6 mb-9">
        Demo Request Received
      </h4>
      <p class="p3 mb-6">
        Thanks {{ firstName }}! Someone from our team will be in touch shortly about next steps.
      </p>
      <p class="p3">
        Have a great day!
      </p>
    </WizardContent>
  </WizardContainer>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import WizardContent from '@/components/shared/WizardContent.vue';

export default {
  name: 'DemoRequestReceived',
  components: {
    WizardContainer,
    WizardContent,
  },
  emits: ['track-page-load'],
  data() {
    return {
      firstName: this.$route.params.firstName,
    };
  },
  async created() {
    if (!this.firstName) {
      this.$router.push({
        name: 'demo-request',
      });
    }
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Demo Request Received' });
  },
};
</script>
